document.addEventListener('DOMContentLoaded', function() {
  const calcBtn = document.getElementById('calc-frete-btn');
  const cepInput = document.getElementById('cep-input');
  const resultsDiv = document.getElementById('frete-results');
  const errorDiv = document.getElementById('frete-error');
  
  const CEP_ORIGEM = '71065130';
  
  // Event Listeners
  calcBtn.addEventListener('click', calcularFrete);
  
  cepInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      calcularFrete();
    }
  });
  
  // Função principal de cálculo
  async function calcularFrete() {
  const cep = cepInput.value.replace(/\D/g, '');
  
  if (cep.length !== 8) {
    showError('CEP inválido. Digite 8 dígitos.');
    return;
  }
  
  const productData = getProductData();
  
  resultsDiv.innerHTML = '<p>Calculando...</p>';
  resultsDiv.classList.add('show');
  errorDiv.style.display = 'none';
  
  try {
    const response = await fetch('https://frenet-proxy.moneysoriginals.workers.dev?t=' + Date.now(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        SellerCEP: CEP_ORIGEM,
        RecipientCEP: cep,
        ShipmentInvoiceValue: productData.price,
        ShippingItemArray: [{
          Weight: productData.weight,
          Length: productData.length,
          Height: productData.height,
          Width: productData.width,
          Quantity: 1
        }]
      })
    });
    
    const data = await response.json();
    
    // ⚠️ DEBUG COMPLETO - OLHE O CONSOLE!
    console.log('═══════════════════════════════════');
    console.log('RESPOSTA COMPLETA DA API FRENET:');
    console.log(JSON.stringify(data, null, 2));
    console.log('═══════════════════════════════════');
    
    if (data.ShippingSevicesArray && data.ShippingSevicesArray.length > 0) {
      // Filtrar Mini Envios
      const filteredServices = data.ShippingSevicesArray.filter(service => {
        const nome = service.ServiceDescription || service.serviceDescription || '';
        return !nome.toLowerCase().includes('mini envios');
      });
      
      if (filteredServices.length > 0) {
        displayResults(filteredServices);
      } else {
        showError('Não foi possível calcular o frete para este CEP.');
      }
    } else {
      showError('Não foi possível calcular o frete para este CEP.');
    }
    
  } catch (error) {
    showError('Erro ao calcular frete. Tente novamente.');
    console.error('Erro Frenet:', error);
  }
}

  
  // Pegar dados do produto
  function getProductData() {
    const productJson = document.querySelector('[data-product-json]');
    const product = productJson ? JSON.parse(productJson.textContent) : null;
    
    return {
      price: product?.price / 100 || 0,
      weight: product?.variants[0]?.weight || 0.3,
      length: 16,
      height: 5,
      width: 11
    };
  }
  
// Exibir resultados
// Exibir resultados
function displayResults(services) {
  let html = '<div class="frete-results-header" onclick="toggleFreteResults()">';
  html += '<h4>Opções de entrega (' + services.length + ')</h4>';
  html += '<span class="toggle-icon"></span>';
  html += '</div>';
  html += '<div class="frete-options">';
  
  console.log('Serviços recebidos:', services);
  
  services.forEach(service => {
    // Pegar dados da API
    const serviceCode = service.ServiceCode || service.serviceCode || '';
    const prazo = parseInt(service.DeliveryTime) || 0;
    const valor = parseFloat(service.ShippingPrice || 0);
    
    // Mapear códigos para nomes amigáveis
    let nome = '';
    if (serviceCode === '03200') nome = 'PAC';
    else if (serviceCode === '03220') nome = 'Sedex';
    else if (serviceCode.includes('LOG')) nome = 'Loggi';
    else if (serviceCode.includes('JADLOG') || serviceCode === '04227') nome = 'Jadlog Package';
    else nome = service.ServiceDescription || serviceCode;
    
    if (!nome) return;
    
    console.log('Serviço:', nome, 'Prazo:', prazo, 'Valor:', valor);
    
    const isSedex = nome.toLowerCase().includes('sedex');
    
    // Lógica de preço: só Sedex mostra valor, resto é GRÁTIS
    const precoDisplay = isSedex 
      ? `R$ ${valor.toFixed(2)}` 
      : '<span style="color: #00a650; font-weight: 700; font-size: 13px;">GRÁTIS</span>';
    
    // Lógica de prazo
    const prazoDisplay = prazo > 0 
      ? `${prazo} dias úteis` 
      : '<span style="color: #86868b;">Consulte o prazo</span>';
    
    html += `
      <div class="frete-option ${isSedex ? 'sedex-option' : ''}">
        <span class="frete-nome">${nome}</span>
        <span class="frete-prazo">${prazoDisplay}</span>
        <span class="frete-valor">${precoDisplay}</span>
        ${isSedex ? `
          <span class="sedex-aviso">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            Após finalizar o pedido, entre em contato no WhatsApp para selecionar o método de envio Sedex
          </span>
        ` : ''}
      </div>
    `;
  });
  
  html += '</div>';
  resultsDiv.innerHTML = html;
  resultsDiv.classList.add('show');
}

  
  // Mostrar erro
  function showError(message) {
    errorDiv.textContent = message;
    errorDiv.style.display = 'block';
    resultsDiv.innerHTML = '';
    resultsDiv.classList.remove('show');
  }
  
  // Toggle expandir/fechar resultados
  window.toggleFreteResults = function() {
    const options = document.querySelector('.frete-options');
    const icon = document.querySelector('.toggle-icon');
    
    if (!options || !icon) return;
    
    if (options.style.display === 'none' || options.style.display === '') {
      options.style.display = 'flex';
      icon.classList.remove('collapsed');
    } else {
      options.style.display = 'none';
      icon.classList.add('collapsed');
    }
  }
});
